<template lang="pug">
  app-modal.modalInformacao(
    titulo="Solicitar Informação",
    :width="width"
    :isDespacho='true'
    @closeModal="closeModal()"
  )
    template(slot="body")
      app-modal-visualiza-pdf(
        v-if="showModalVisualizaPdf",
        @closeModal="closeModalVisualizaPdf",
        :titulo="tituloModal",
        :tipo="tipoModal",
        :conteudo="conteudoModal",
        :isVTN="false",
        :isImagem="isImagem"
        :tituloDocumento="tituloDocumento"
      )
      div.extra-margin-bottom(v-for="(dado, index) in dados", :key="dado.id")
        div.flex
          p
            b Solicitações: {{dado.assunto}}
          p
            b.status(v-if="dado.status === 'CANCELADA'") CANCELADA
          a.link(v-if="dado.mensagemList.length === 1 && dado.status !== 'RESPONDIDA' && dado.status !== 'CANCELADA'", @click="cancelarSolicitacao(dado.id)") Cancelar solicitação &nbsp
            i.fa.fa-times
        el-collapse(v-model='abaAtiva')
          el-collapse-item(
            v-for="(msg, index) in dado.mensagemList",
            :key="msg.id"
          )
            template(slot="title")
              div.flex.title.full-width
                span {{msg.nomeRemetente}}
                span(type="data") {{ msg.dataEnviada }} &nbsp
            el-row.margin-top()
              p
                b Setor Origem:
                span &nbsp {{ dado.setorOrigem }}
              p
                b Setor Requerido:
                span &nbsp {{ dado.setorRequerido }}
              p
                b Responsável:
                span &nbsp {{ dado.responsavel }}
            el-row.margin-top
              p
                b Data de Vencimento:
                span &nbsp {{ removeNull(dado.dataVencimento) }}
            el-row.margin-top
              p
               b {{ index === 0 ? 'Despacho:' : 'Resposta:'}}
              p(v-html="msg.conteudo")
            el-row.margin-top
              el-table(
                  :data='dado.mensagemList[index].anexoList',
                  stripe
                )
                  el-table-column.td-column-anexo(
                    prop='nome',
                  )
                  el-table-column.td-column-anexo(
                    align="center",
                    width="85"
                    )
                      template(slot-scope='scope')
                        app-action-button(
                          v-if="isEstadoAp"
                          :disabled="!isDocumentoParaVisualizacao(scope.row)"
                          :cor="!isDocumentoParaVisualizacao(scope.row) ? '#C0C4CC' : '#666666'",
                          :text="!isDocumentoParaVisualizacao(scope.row) ? 'Não é possível exibir esse arquivo': 'Visualizar' ",
                          icone="eye",
                          fontSize="18",
                          @click="abrirDocumento(scope.row)"
                        )
                        app-action-button(
                          icone="download",
                          nome="file_download",
                          @click="download(scope.row)",
                          hoverColor="#009f61",
                          text="Baixar anexo"
                        )
      div.extra-margin-top
        validation-observer(ref='validation' tag='form')
          el-row
            el-col(:span="12")
              app-label(
                label="Setor:",
                :required="true"
              )
              validation-provider(rules="required", v-slot="{ errors }")
                el-select.width90.input(
                  clearable,
                  filterable,
                  :class="{'erro' : errors.length}",
                  placeholder="Selecione",
                  v-model='setorRequerido',
                  @change='(param) => showInfoVencimento(param)'
                  name="setorEncaminhar",
                )
                  el-option(
                    v-for='setor in setores'
                    :key='setor.id'
                    :label='setor.codigo',
                    :value='setor.codigo'
                  )
                span.help.erro( v-if="errors.length" ) {{ errors[0] }}
            el-col(:span="12")
              app-label(
                label="Data de vencimento:",
                :required="false"
              )
              el-date-picker.input.full-width(
                placeholder="Data de vencimento",
                disabled,
                format="dd/MM/yyyy",
                type='date'
                v-model='prazo',
                :required="false",
                name="prazo"
              )
          el-row.margin-top
            el-col(:span="24")
              app-label.mt-20(
                label="Assunto:",
                :required="true"
              )
              validation-provider(rules="required", v-slot="{ errors }")
                el-input.input(
                  name="assunto",
                  v-model="assunto",
                  :class="{'erro' : errors.length}"
                )
                span.help.erro( v-if="errors.length" ) {{ errors[0] }}
          el-row.margin-top
            el-col(:span="24")
              app-label.mt-20(
                label="Despacho:",
                :required="true"
              )
              validation-provider(rules="required", v-slot="{ errors }")
                app-editor-texto.input(
                  :value="mensagem",
                  @onTextChange="onTextChange"
                  :class="{'erro' : errors.length}"
                  ref="editorTexto"
                )
                span.help.erro( v-if="errors.length" ) {{ errors[0] }}
          el-row.margin-top
            p.label.mt-20 Anexos mensagem
          el-row.margin-top
            validation-provider(v-slot="{ errors }")
              app-anexo(
                :id="'upload-informacao-solicitar'"
                @removeFile="removeFile",
                @uploadFile="uploadFile"
                :files="anexos"
                scope="anexos",
                v-model="anexos",
                :errors="errors",
                :exibirDownload="false"
              )
    template(slot="footer")
      .flex
        el-button.btn(
          type="default",
          size="small",
          @click="closeModal()"
        )
          span.center
            i.fa.fa-times
            b &nbsp Cancelar
        el-button.btn(
          type="success",
          size="small",
          @click="sendMessage()"
        )
          span.center
            i.fa.fa-share-square
            b &nbsp Enviar
</template>

<script>
import moment from 'moment'
import axios from '@/utils/api'
import AppLabel from '@/components/AppLabel'
import AppModal from '@/components/AppModal'
import AppAnexo from '@/components/AppAnexo'
import messages from '@/constants/messages'
import AppEditorTexto from '@/components/AppEditorTexto'
import AppDownloadArquivo from '@/components/AppDownloadArquivo'
import AppNotificacao from '@/components/mixins/AppNotificacao'
import FileHelper from '@/utils/fileHelper'
import { mapActions } from 'vuex'
import AppActionButton from '../../../../components/AppActionButton'
import AppModalVisualizaPdf from '@/screens/analise/components/AppModalVisualizaPdf'
import utils from '@/utils/utils'
const {visualizarDocumentosPDF} = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default

export default {
  components: {
    AppModal,
    AppLabel,
    AppAnexo,
    AppDownloadArquivo,
    AppEditorTexto,
    AppActionButton,
    AppModalVisualizaPdf
  },

  mixins: [AppNotificacao],
  props: {
    width: {
      type: Number,
      default: 850
    },
    idProcesso: {
      required: true
    },
    idDespacho: {
      required: true
    },
    setor: {
      required: false
    }
  },

  data () {
    return {
      dados: null,
      abaAtiva: undefined,
      moment,
      setores: [],
      setorRequerido: null,
      usuario: null,
      anexoList: [],
      prazo: null,
      assunto: null,
      mensagem: null,
      anexos: [],
      isEstadoMa: process.env.ESTADO === 'ma',
      isEstadoAp: process.env.ESTADO === 'ap',
      tituloModal: '',
      tipoModal: null,
      conteudoModal: null,
      showModalVisualizaPdf: false,
      isImagem: false,
      tituloDocumento: ''
    }
  },

  async created () {
    const data = await axios({
      method: 'GET',
      url: `solicitarInformacao/setoresSolicitacao`,
      error: true
    })
    this.usuario = await this.getUsuario()
    this.setores = data.filter(s => s.codigo !== this.usuario.perfilSelecionado.setor.codigo)
    this.buscar()
  },

  methods: {
    ...mapActions({
      downloadDocumentos: 'download/download',
      getUsuario: 'auth/getUsuario'
    }),
    async download (anexo) {
      const arquivo = await this.downloadDocumentos(anexo)

      FileHelper.saveFile(arquivo, anexo.nome)
    },

    async buscar () {
      this.dados = await axios({
        method: 'GET',
        url: `solicitarInformacao/processo/${this.idProcesso}/setor/${this.setor}`,
        error: true
      })
    },
    async uploadFile (file) {
      this.anexos.push({ key: file.response, nome: file.name })
    },
    removeFile (file) {
      const arquivo = this.anexos.findIndex(obj => obj === file)
      this.anexos.splice(arquivo, 1)
    },
    async checkValidacao () {
      const valido = await this.$refs.validation.validate()
      if (!valido) {
        this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING, 'Por favor, preencha os campos obrigatórios.')
        return false
      }
      return true
    },
    closeModal () {
      this.$emit('closeModal')
    },
    onTextChange (value) {
      this.mensagem = value
    },

    cancelarSolicitacao (id) {
      this.$confirm(
        'Após o cancelamento da solicitação, esta ainda será visualizada pelo setor requerido, com o status ‘Cancelada’. Tem certeza que deseja continuar?',
        'Atenção',
        {
          confirmButtonText: 'Confirmar',
          cancelButtonText: 'Cancelar',
          type: 'warning'
        }
      )
        .then(async () => {
          axios({
            method: 'DELETE',
            url: `solicitarInformacao/${id}`,
            error: true
          }).then(() => {
            this.closeModal()
            this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS, 'A solicitação de Informação foi cancelada.')
          })
        })
        .catch(() => {
        })
    },

    async getPrazoVencimentoBySetor (data) {
      const response = await axios({
        method: 'POST',
        url: `solicitarInformacao/solicitacaoPrazo`,
        data: data,
        loader: false
      })

      return response
    },

    async showInfoVencimento (codigoSetor) {
      const today = new Date()
      if (process.env.ESTADO === 'pa') {
        const data = {
          codigoSetor: codigoSetor,
          idProcesso: this.idProcesso.toString()
        }
        const prazoNotificacao = await this.getPrazoVencimentoBySetor(data)
        // Pega a data atual e soma com o prazo de Notificação
        if (prazoNotificacao !== '') {
          this.prazo = today.setDate(today.getDate() + prazoNotificacao)
        } else {
          this.prazo = ''
        }
      } else {
        this.prazo = today.setDate(today.getDate() + 10)
      }
    },

    async sendMessage () {
      if (!await this.checkValidacao()) {
        return
      }
      const obj = {
        setorRequerido: this.setorRequerido,
        despacho: {id: this.idDespacho},
        dataVencimento: moment(this.prazo).format('YYYY-MM-DD'),
        conversa: {
          assunto: this.assunto,
          processo: {
            id: this.idProcesso
          },
          mensagemList: [
            {
              conteudo: this.mensagem,
              anexoList: this.anexos,
              dataLimiteResposta: this.prazo
            }
          ]
        }
      }

      axios({
        method: 'POST',
        url: `solicitarInformacao/create`,
        error: true,
        data: obj
      }).then(() => {
        this.closeModal()
        this.showNotificacao(
          this.$messages.TIPO_SUCCESS,
          this.$messages.TITULO_SUCCESS,
          'A solicitação de Informação foi enviada para o setor responsável. Aguarde o retorno para  continuar a análise.'
        )
        this.$emit('setHasInformacoa', true)
        if (this.isEstadoMa) {
          this.$router.back()
        }
      }).catch((e) => {
        let mensagemErro = ''
        if (e.erros !== null && e.erros.length > 0) {
          e.erros.forEach(mensagem => {
            mensagemErro += mensagem + ' '
          })
        } else {
          mensagemErro = messages.ERROR_MESSAGE
        }
        this.showNotificacao(
          this.$messages.TIPO_ERROR,
          this.$messages.TITULO_ERROR,
          mensagemErro
        )
      })
    },

    removeNull (value) {
      if (value) {
        return value
      }

      return '-'
    },

    abrirImagem (row) {
      let extensao = utils.getExtensionFile(row.nome)
      return visualizarDocumentosPDF.extensaoImagens.includes(extensao)
    },

    isDocumentoParaVisualizacao (row) {
      let extensao = utils.getExtensionFile(row.nome)
      return visualizarDocumentosPDF.extensaoVisualizar.includes(extensao)
    },

    abrirDocumento (documento) {
      this.tipoModal = 'DOCUMENTO_MENSAGEM'
      this.tituloModal = 'Documento'
      this.conteudoModal = documento.id
      this.isImagem = this.abrirImagem(documento)
      this.showModalVisualizaPdf = true
      this.tituloDocumento = 'Documento'
    },

    closeModalVisualizaPdf () {
      this.showModalVisualizaPdf = false
    }
  }
}
</script>

<style scoped lang="scss">
p.message {
  width: 80%;
  margin: 0 auto;
}

.flex {
  margin-top: 5px;
  display: flex;
  justify-content: space-between;
}

.title {
  font-weight: 400;
  color: #909399;
  font-size: 16px;
}

.status {
  color: #b22222;
}

.width90 {
  width: 80%;
}

.full-width {
  width: -webkit-fill-available;
}

.bold {
  font-weight: bold;
}

.link {
  cursor: pointer;
  color: #009f61;
  &:hover {
    font-weight: bold;
    color: #3bb281 !important;
  }
}

.mt-20 {
  margin-top: 20px;
}

.extra-margin-top {
  margin-top: 15px !important;
}

@media (max-width: 780px) {
  .modalInformacao {
    width: 360px !important;
    position: fixed !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/analise/components/modal/AppModalInformacao.vue